import { Box, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import Card from '../../../../components/card/Card';
import ZipcodeInputWithButton from '../../../../components/zipcodeInputWithButton/ZipcodeInputWithButton';
import { useUserPrefs } from '../../../../context/UserPrefsProvider';

export default function RateCompareLauncher(): JSX.Element {
  const { formatMessage } = useIntl();
  const history = useHistory();
  const { userPrefs, setUserPrefs } = useUserPrefs();

  return (
    <Box
      display="flex"
      flexDirection={{ xs: 'column', sm: 'row' }}
      flexWrap="wrap"
      gap="2rem"
      maxWidth="990px"
      mx="auto"
    >
      <Box flex="3 1">
        <Typography component="h2" fontSize="2rem" fontWeight="500" lineHeight="1.2" mb="0.5rem">
          {formatMessage({ id: 'homepage.rateCompare.headline' })}
        </Typography>
        <Typography fontSize="1.25rem" fontWeight="300">
          {formatMessage({ id: 'homepage.rateCompare.description' })}
        </Typography>
      </Box>
      <Box flex="1 1" minWidth="300px">
        <Card>
          <Box display="flex" flexDirection="column" gap="16px">
            <ZipcodeInputWithButton
              buttonText={formatMessage({ id: 'homepage.rateCompare.startButton' })}
              zipcode={userPrefs.zipcode}
              onSubmitZipcode={(zipcode) => {
                setUserPrefs({ zipcode });
                history.push('/rates');
              }}
            />
            <Box fontSize="0.85rem">
              {formatMessage({ id: 'homepage.rateCompare.formDetails' })}
            </Box>
          </Box>
        </Card>
      </Box>
    </Box>
  );
}
